import { render, staticRenderFns } from "./PersonalInfoView.vue?vue&type=template&id=368af0c0&scoped=true"
import script from "./PersonalInfoView.vue?vue&type=script&lang=js"
export * from "./PersonalInfoView.vue?vue&type=script&lang=js"
import style0 from "./PersonalInfoView.vue?vue&type=style&index=0&id=368af0c0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "368af0c0",
  null
  
)

export default component.exports